import React, { useState, useEffect, useCallback } from 'react';

const SHOW_AFTER_PX = 350;

const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ width: 14, height: 14, flexShrink: 0 }}>
    <path d="M12 3v12" /><path d="M6 9l6 6 6-6" /><path d="M5 21h14" />
  </svg>
);

export const BrochureTicker = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('agTickerDismissed') === '1');

  const onScroll = useCallback(() => {
    if (window.scrollY > SHOW_AFTER_PX) setVisible(true);
  }, []);

  useEffect(() => {
    if (dismissed) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [dismissed, onScroll]);

  const handleClose = useCallback(() => {
    setVisible(false);
    setDismissed(true);
    sessionStorage.setItem('agTickerDismissed', '1');
  }, []);

  if (dismissed) return null;

  return (
    <>
      <style>{`
        .ag-card{position:fixed;right:16px;top:50%;transform:translateY(-50%) translateX(120%);z-index:9990;width:192px;border-radius:12px;overflow:hidden;background:linear-gradient(180deg,#072A4D 0%,#0A3D6E 100%);color:#fff;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;box-shadow:-4px 0 24px rgba(7,42,77,.35),0 8px 32px rgba(0,0,0,.2);transition:transform .45s cubic-bezier(.2,.7,.2,1);border:1.5px solid rgba(212,166,74,.4)}
        .ag-card.is-visible{transform:translateY(-50%) translateX(0)}
        .ag-card__header{background:#D4A64A;color:#072A4D;padding:10px 14px;display:flex;align-items:center;justify-content:space-between}
        .ag-card__badge{display:flex;align-items:center;gap:6px;font-weight:800;font-size:10.5px;letter-spacing:.12em;text-transform:uppercase}
        .ag-card__dot{width:7px;height:7px;border-radius:50%;background:#072A4D;animation:ag-pulse 1.6s ease-in-out infinite}
        @keyframes ag-pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.55;transform:scale(.78)}}
        .ag-card__close{border:0;background:transparent;color:#072A4D;font-size:18px;cursor:pointer;padding:0 2px;line-height:1;font-weight:700;opacity:.7;transition:opacity .2s}
        .ag-card__close:hover{opacity:1}
        .ag-card__body{padding:14px;display:flex;flex-direction:column;gap:12px}
        .ag-card__item{display:flex;flex-direction:column;gap:6px}
        .ag-card__text{font-size:11.5px;color:#c8d8ea;line-height:1.4}
        .ag-card__text strong{color:#fff;font-weight:700}
        .ag-card__link{display:inline-flex;align-items:center;gap:5px;color:#D4A64A;text-decoration:none;font-weight:700;font-size:12px;border-bottom:1px dashed rgba(212,166,74,.45);padding-bottom:1px;transition:color .2s,border-color .2s;line-height:1.3}
        .ag-card__link:hover{color:#fff;border-bottom-color:#fff}
        .ag-card__sep{height:1px;background:rgba(255,255,255,.1);margin:0}
        .ag-card__consult{text-align:center;font-size:11.5px;color:#c8d8ea;line-height:1.4}
        .ag-card__consult strong{color:#D4A64A;font-weight:700}
        @media(max-width:640px){.ag-card{width:170px;right:10px}.ag-card__text{font-size:11px}.ag-card__link{font-size:11px}}
      `}</style>
      <div className={`ag-card${visible ? ' is-visible' : ''}`} role="region" aria-label="Brochure downloads" data-testid="brochure-ticker">
        <div className="ag-card__header">
          <div className="ag-card__badge">
            <span className="ag-card__dot" />
            <span>New &middot; Brochures</span>
          </div>
          <button className="ag-card__close" type="button" aria-label="Dismiss" onClick={handleClose} data-testid="ticker-close-btn">&times;</button>
        </div>
        <div className="ag-card__body">
          <div className="ag-card__item">
            <span className="ag-card__text"><strong>Bespoke Leadership Hiring</strong> — get the brief on one page.</span>
            <a className="ag-card__link" href="/downloads/AvantGarde-LeadershipHiring-Brief.pdf" download>
              Download 1-page brief <DownloadIcon />
            </a>
          </div>
          <div className="ag-card__sep" />
          <div className="ag-card__item">
            <span className="ag-card__text">Full story &middot; approach &middot; about Sameer Pant</span>
            <a className="ag-card__link" href="/downloads/AvantGarde-LeadershipHiring-Brochure.pdf" download>
              Download 3-page brochure <DownloadIcon />
            </a>
          </div>
          <div className="ag-card__sep" />
          <div className="ag-card__consult">
            Free <strong>30-min consultation</strong> &middot; we confirm within 24 hours.
          </div>
        </div>
      </div>
    </>
  );
};
